import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConteudoPortal = '/service/portal/conteudo/transparencia/'

class PortalService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        const categoria = config.categoria ? config.categoria : null
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        this.state = {
            paramCategoria: categoria ? `?categoria=${categoria}` : '',
            categoria: categoria ? categoria : null,
        }
    }

    getMenu() {
        return this.conex.get(urlConteudoPortal + 'menu' + this.state.paramCategoria)
    }

    getConteudoPorId(conteudo) {
        return this.conex.get(
            urlConteudoPortal +
                `conteudo?${conteudo ? `id=${conteudo}` : ''}${conteudo && this.state.categoria ? '&' : ''}${
                    this.state.categoria ? `categoria=${this.state.categoria}` : ''
                }`
        )
    }

    getGruposPorConteudo(conteudo) {
        return this.conex.get(urlConteudoPortal + 'gruposPorConteudo/' + conteudo)
    }

    download(caminho) {
        return this.conex.post(urlConteudoPortal + 'download/', {
            caminho: caminho,
        })
    }

    getLinks() {
        return this.conex.get(urlConteudoPortal + 'links/')
    }
}

export default PortalService
